import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsFillFilePdfFill, BsQuestionCircle } from "react-icons/bs";
import { getStatusColor } from "../../utils/colors";
import { Status } from "../statuses/store/slice";
import styles from "./status-badge.module.scss";

type Props = {
  status: Status | null;
  showText?: boolean;
  showDocumentIcon?: boolean;
};

const StatusBadge = ({ status, showText, showDocumentIcon }: Props) => {
  if (!status) return <span>-</span>;

  return (
    <div className={styles.wrapper}>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`status-${status.id}-tooltip`}>
            {status.description}
          </Tooltip>
        }
      >
        <span>
          {showText ? (
            status.name
          ) : (
            <Badge bg={getStatusColor(status.code)}>{status.name}</Badge>
          )}{" "}
          {showDocumentIcon && <BsFillFilePdfFill className="text-danger" />}{" "}
          <BsQuestionCircle />
        </span>
      </OverlayTrigger>
    </div>
  );
};

export default StatusBadge;
